import React, { type BaseSyntheticEvent, useState } from 'react';
import { translate } from 'javascripts/translations/i18n';
import styled from 'styled-components';
import { Button, Switch } from '@companycam/slab-web';

import Modal from 'components/shared/DesignSystem/Modal';

import { useModal } from 'components/shared/hooks';
import toast from 'helpers/toast';
import { Steven } from 'helpers/steven';
import { type PagePdfExportConfig } from '../hooks/usePagePdfExport';

const StyledModal = styled(Modal)`
  width: 553px;
  display: flex;
  flex-direction: column;
`;

export type PagePdfExportModalProps = {
  onExportClick: (exportOptions: PagePdfExportConfig) => void;
  loading: boolean;
};

const PagePdfExportModal = ({
  onExportClick,
  loading,
}: PagePdfExportModalProps) => {
  const { hideModal } = useModal();

  const [saveToDocuments, setSaveToDocuments] = useState(false);

  const handleExportClick = () => {
    Steven.elementClicked({
      id: 'project_page_export_modal',
      content: 'common.export',
      action: 'export_pdf_clicked',
      type: 'page',
    });

    onExportClick({
      saveToDocuments,
    });
    hideModal();

    toast.show({
      title: translate('projects.pages.exportPdf.confirmToastTitle'),
      message: saveToDocuments
        ? translate('projects.pages.exportPdf.saveToDocsMsg')
        : null,
    });
  };

  const handleSwitchToggle = (e: BaseSyntheticEvent) => {
    Steven.elementClicked({
      id: 'export_page_options',
      content: `${e.target.checked ? 'on' : 'off'}`,
      action: `export_page_options_toggled`,
      type: 'save_to_documents',
    });

    setSaveToDocuments((prevState) => !prevState);
  };

  return (
    <StyledModal
      isOpen
      onRequestClose={hideModal}
      title={translate('common.exportToPdf')}
      className="modal-content-wrap"
      style={undefined}
    >
      <Switch
        label={translate('projects.pages.exportPdf.saveToDocuments')}
        id="saveToDocuments"
        pressed={saveToDocuments}
        onClick={handleSwitchToggle}
        disabled={loading}
      />

      <div className="btn-container">
        <Button color="primary" onClick={handleExportClick} loading={loading}>
          {translate('common.export')}
        </Button>
      </div>
    </StyledModal>
  );
};

export default PagePdfExportModal;
